import { h } from "preact";
import { calculateForeground } from "../internal_utilities/utilities";

function InvalidCard({ title, color, ctaText, explainertext, onClose }) {
  return (
    <div className="corner-modal-card bg-white rounded-lg m-3 shadow-lg overflow-hidden tex-center p-8 max-w-xl">
      <h1 className="text-center">{title}</h1>
      <p className="text-center mt-3">{explainertext}</p>
      <div className="flex justify-center">
        <a
          href="#"
          onClick={onClose}
          ref={node => {
            if (node) {
              node.style.setProperty("background", color, "important");
              node.style.setProperty(
                "color",
                calculateForeground(color),
                "important"
              );
            }
          }}
          className="mt-5 px-8 py-4 rounded-lg max-w-fit opacity-100 hover:opacity-90 transition-opacity text-center"
        >
          {ctaText}
        </a>
      </div>
    </div>
  );
}

export default InvalidCard;
